import {
  IconButtonProps,
  IconButton,
  CircularProgress
} from '@mui/material'
import SaveIcon from '@mui/icons-material/Save'
import React from 'react'

interface SaveIconProps extends IconButtonProps {
  fontSize: 'small' | 'medium'
  isLoading?: boolean
}

export const SaveIconButton: React.FC<SaveIconProps> = ({
  fontSize,
  isLoading = false,
  ...iconButtonProps
}) => {
  return (
    <IconButton aria-label='delete' disabled={isLoading} {...iconButtonProps}>
      {isLoading ? (
        <CircularProgress size={fontSize} />
      ) : (
        <SaveIcon fontSize={fontSize} />
      )}
    </IconButton>
  )
}
